import "./LoginPage.style.css";

import { useState } from "react";
import { LoginForm } from "./LoginForm/LoginForm";
import { RegisterForm } from "./RegisterForm/RegisterForm";
import { Button } from "../../components/base/Button/Button";

interface LoginPageProps {
  setUsername: (newUsername: string) => void;
}

export const LoginPage = ({ setUsername }: LoginPageProps) => {
  const [isLogin, setIsLogin] = useState<boolean>(true);

  const handleToggleLogin = () => {
    setIsLogin((prevState) => !prevState);
  };

  return (
    <div className="login-page">
      {isLogin ? (
        <div className="login-page__content">
          <div className="login-page__title">Вход</div>
          <LoginForm setUsername={setUsername} />
          <div className="login-page__navigate-button-block">
            Еще нет аккаунта?
            <Button text="Создать аккаунт" onClick={handleToggleLogin} />
          </div>
        </div>
      ) : (
        <div className="login-page__content">
          <div className="login-page__title">Регистрация</div>
          <RegisterForm setIsLogin={setIsLogin} />
          <div className="login-page__navigate-button-block">
            Уже есть аккаунт?
            <Button text="Войти в аккаунт" onClick={handleToggleLogin} />
          </div>
        </div>
      )}
    </div>
  );
};
